import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from '@/views/home.vue'
import Led from '@/views/led.vue'
import AnionScreen from '@/views/anionScreen.vue'
import FlowerScreen from '@/views/flowerScreen.vue'
import AnionBigScreen from '@/views/anionBigScreen.vue'
import Pollen from '@/views/pollen.vue'
import PollenScreen from '@/views/pollenScreen.vue'
import GzPollenScreen from '@/views/gzPollenScreen.vue'
import GzPollen from '@/views/gzPollen.vue'
import FlowerMap from '@/views/flowerMap.vue'
import AllFlowerMap from '@/views/allFlowerMap.vue'
const routes = [
  {
    path: '/', //负氧离子
    component: Home
  },
  {
    path: '/anionBigScreen', //负氧离子大屏 横屏
    component: AnionBigScreen
  },
  {
    path: '/led', //led氧离子
    component: Led
  },
  {
    path: '/anionScreen',
    component: AnionScreen
  },
  {
    path: '/flowerScreen', //赏花大屏
    component: FlowerScreen
  },
  {
    path: '/pollen', //花粉浓度 竖屏 1080 1920
    component: Pollen
  },
  {
    path: '/pollenScreen', //花粉浓度 横屏  1920 1080
    component: PollenScreen
  },
  {
    path: '/gzPollenScreen', //广州花粉浓度 横屏  1920 1080
    component: GzPollenScreen
  },
  {
    path: '/gzPollen', //广州花粉浓度 竖屏 1080 1920
    component: GzPollen
  },
  {
    path: '/flowerMap', //赏花地图
    component: FlowerMap
  },
  {
    path: '/allFlowerMap', //赏花地图
    component: AllFlowerMap
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router
